import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserNamePipeModule } from '@wilson/account';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { map } from 'rxjs';
import { TrainingQualificationsFinalizeDrawerService } from '../training-qualifications-finalize-drawer.service';

@Component({
  selector: 'wilson-training-qualifications-finalize-user-section',
  imports: [CommonModule, UserNamePipeModule, NzTagModule, TranslatePipe],
  templateUrl: './training-qualifications-finalize-user-section.component.html',
  styleUrl: './training-qualifications-finalize-user-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingQualificationsFinalizeUserSectionComponent {
  private readonly trainingQualificationsFinalizeDrawerService = inject(
    TrainingQualificationsFinalizeDrawerService,
  );

  protected usersFromTrainingsToFinalize$ =
    this.trainingQualificationsFinalizeDrawerService.trainingsToFinalize$.pipe(
      map((trainings) => [
        ...new Set(trainings.map((training) => training.userId)),
      ]),
    );
}
